import { firebaseAuthService } from '@/core/services';
import type { UserRepository } from '@/features/app/user/domain/repositories/user-repository';

/**
 * Retorna o UID do usuário da sessão atual.
 * Prioriza o Firebase Auth (fonte de verdade da sessão). O cache local de `User` pode ter mais de
 * um registro e `getUser()` retorna apenas uma entrada arbitrária — usar auth evita carregar dados
 * (serviços, clientes, etc.) de outra conta no mesmo dispositivo.
 */
export class GetUserUidUseCase {
  constructor(private readonly userRepository: UserRepository) {}

  async execute(): Promise<string | null> {
    const authUid = firebaseAuthService.getCurrentUserUid();
    if (authUid) return authUid;
    const user = await this.userRepository.getUser();
    return user?.id ?? null;
  }
}
